import Vue from "vue";
import pc_header from "@/pc/components/header";
import pc_menu from "@/pc/components/menu";
Vue.component("pc-header", pc_header);
Vue.component("pc-menu", pc_menu);

export default [
	{
		name: "pcIndex",
		path: "/",
		component: () => import("@/pc/pages/manage/myTask/index.vue"),
		meta: {
			title: "首页"
		}
	},
	{
		name: "modelList",
		path: "/model/list",
		component: () => import("@/pc/pages/index/model/list"),
		meta: {
			title: "问题列表"
		}
	},
	// {
	//   name: 'topicList',
	//   path: '/topic/list',
	//   component: () => import('@/pc/pages/index/topic/list'),
	//   meta: {
	//     title: '话题分类',
	//   }
	// },
	{
		name: "modelDetail",
		path: "/model/detail",
		component: () => import("@/pc/pages/index/model/detail"),
		meta: {
			title: "问题详情"
		}
	},
	{
		name: "manage",
		path: "/admin",
		component: () => import("@/pc/pages/manage/index"),
		meta: {
			title: "管理"
		}
	},
	{
		name: "manageDetail",
		path: "/manage/detail",
		component: () => import("@/pc/pages/manage/detail"),
		meta: {
			title: "管理"
		}
	},
	{
		name: "my",
		path: "/me",
		component: () => import("@/pc/pages/my/index"),
		meta: {
			title: "个人中心"
		}
	},
	{
		name: "notice",
		path: "/message",
		component: () => import("@/pc/pages/notice/index"),
		meta: {
			title: "提醒"
		}
	},
	{
		name: "myFollow",
		path: "/my/follow/detail",
		component: () => import("@/pc/pages/my/follow/detail"),
		meta: {
			title: "个人中心-关注"
		}
	},
	{
		name: "myFavorite",
		path: "/my/favorite/detail",
		component: () => import("@/pc/pages/my/favorite/detail"),
		meta: {
			title: "个人中心-收藏夹"
		}
	},
	{
		name: "sensitive",
		path: "/manage/sensitive",
		component: () => import("@/pc/pages/manage/sensitive"),
		meta: {
			title: "敏感词管理"
		}
	},
	{
		name: "organisation",
		path: "/manage/organisation",
		component: () => import("@/pc/pages/manage/organisation"),
		meta: {
			title: "组织名映射"
		}
	},
	{
		name: "backStage",
		path: "/manage/backStage",
		component: () => import("@/pc/pages/manage/backStage"),
		meta: {
			title: "版块维护"
		}
	},
	{
		name: "modelInformation",
		path: "/manage/modelInformation",
		component: () => import("@/pc/pages/manage/modelInformation"),
		meta: {
			title: "车型信息"
		}
	},
	{
		name: "modelComparison",
		path: "/manageComparison",
		component: () => import("@/pc/pages/modelComparison/index"),
		meta: {
			title: "车型对比"
		}
	},
	{
		name: "leagueTable",
		path: "/manage/leagueTable",
		component: () => import("@/pc/pages/manage/leagueTable"),
		meta: {
			title: "积分榜"
		}
	},
	{
		name: "question",
		path: "/manage/question",
		component: () => import("@/pc/pages/manage/question"),
		meta: {
			title: "问题管理"
		}
	},

	// 问卷
	{
		name: "user",
		path: "/manage/user",
		component: () => import("@/pc/pages/manage/user"),
		meta: {
			title: "用户管理"
		}
	},
	{
		name: "manageGroup",
		path: "/manage/manageGroup",
		component: () => import("@/pc/pages/manage/manageGroup"),
		meta: {
			title: "管理组"
		}
	},
	{
		name: "announcement",
		path: "/manage/announcement",
		component: () => import("@/pc/pages/manage/announcement"),
		meta: {
			title: "导师任务管理"
		}
	},
	{
		name: "questionManage",
		path: "/manage/questionManage",
		component: () => import("@/pc/pages/manage/questionManage"),
		meta: {
			title: "问卷管理"
		}
	},
	{
		name: "analysis",
		path: "/manage/analysis",
		component: () => import("@/pc/pages/manage/analysis"),
		meta: {
			title: "分析下载"
		}
	},
	{
		name: "myQuestion",
		path: "/manage/myQuestion",
		component: () => import("@/pc/pages/manage/myQuestion"),
		meta: {
			title: "我的问卷"
		}
	},
	{
		name: "myPoints",
		path: "/manage/myPoints",
		component: () => import("@/pc/pages/manage/myPoints/index.vue"),
		meta: {
			title: "我的积分"
		}
	},
	{
		name: "myTask",
		path: "/manage/myTask",
		component: () => import("@/pc/pages/manage/myTask/index.vue"),
		meta: {
			title: "我的任务"
		}
	},
	{
		name: "myTaskEditor",
		path: "/manage/myTaskEditor",
		component: () => import("@/pc/pages/manage/myTaskEditor/index.vue"),
		meta: {
			title: "我的任务"
		}
	},
	{
		name: "allQuery",
		path: "/manage/allQuery",
		component: () => import("@/pc/pages/manage/allQuery/index.vue"),
		meta: {
			title: "全网任务查询"
		}
	},
	{
		name: "allQueryDetail",
		path: "/manage/allQueryDetail",
		component: () => import("@/pc/pages/manage/allQueryDetail/index.vue"),
		meta: {
			title: "全网任务查询详情"
		}
	},
	{
		name: "myMessage",
		path: "/manage/myMessage",
		component: () => import("@/pc/pages/manage/myMessage/index.vue"),
		meta: {
			title: "我的消息"
		}
	},
	{
		name: "myMessageEditor",
		path: "/manage/myMessageEditor",
		component: () => import("@/pc/pages/manage/myMessageEditor/index.vue"),
		meta: {
			title: "我的消息"
		}
	},
	{
		name: "mySend",
		path: "/manage/mySend",
		component: () => import("@/pc/pages/manage/mySend/index.vue"),
		meta: {
			title: "我的派发"
		}
	},
	{
		name: "mySendDetail",
		path: "/manage/mySendDetail",
		component: () => import("@/pc/pages/manage/mySendDetail"),
		meta: {
			title: "我的派发详情"
		}
	},

	/* {
	  name: 'editQuestion',
	  path: '/manage/editQuestion',
	  component: () => import('@/pc/pages/manage/editQuestion'),
	  meta: {
		title: '编辑问卷',
	  }
	}, */

	// tduck
	{
		path: "/project/form",
		meta: { requireLogin: false },
		component: () =>
			import(/* webpackChunkName: 'root' */ "@/pc/pages/form"),
		children: [
			{
				path: "",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/editor"
					)
			},
			{
				path: "editor",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/editor"
					)
			},
			{
				path: "logic",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/logic"
					)
			},
			{
				path: "preview",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/preview"
					)
			},
			{
				path: "setting",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/setting"
					)
			},
			{
				path: "publish",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/publish"
					)
			},
			{
				path: "theme",
				meta: { requireLogin: true },
				component: () =>
					import(
						/* webpackChunkName: 'root' */ "@/pc/pages/form/theme"
					)
			}
		]
	},

	{
		name: "createQuestion",
		path: "/manage/createQuestion",
		component: () => import("@/pc/pages/manage/createQuestion"),
		meta: {
			title: "创建问卷"
		}
	}
];



// WEBPACK FOOTER //
// ./src/router/pc.js